import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import {
  type PlaceDetails,
  publicForwardGeocoding as generatedPublicForwardGeocoding,
  type PublicForwardGeocodingParams,
} from '@generated/search-bff';

/**
 * Fetch place details based on the original point provided using the `/api/v2/public/geocode/forward` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/geocoding/publicForwardGeocoding Search API Documentation}
 */
export async function publicForwardGeocoding(
  params: PublicForwardGeocodingParams,
  apiConfig: ApiConfig,
): Promise<ApiResult<PlaceDetails[]>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'publicForwardGeocoding');
    const data = await generatedPublicForwardGeocoding(params, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
